import React from 'react'
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Link,
} from '@react-pdf/renderer'
import moment from 'moment'
import avatarBlank from '../../../../../assets/images/avatarBlank.jpeg'

const styles = StyleSheet.create({
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 40,
    right: 0,
    textAlign: 'left',
    color: 'grey',
  },
  ambuNet: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 40,
    textAlign: 'right',
    color: 'grey',
  },
})

const TextRow = ({ label, value }) => (
  <View
    style={{
      flexDirection: 'row',
      borderBottom: 1,
      fontSize: 14,
    }}
  >
    <View
      style={{
        width: '50%',
        backgroundColor: '#3E4E50',
        paddingHorizontal: 5,
        paddingVertical: 2,
        flexWrap: 'wrap',
      }}
    >
      <Text style={{ fontWeight: 'bold', color: 'white' }}>{label}</Text>
    </View>
    <View
      style={{
        width: '50%',
        paddingHorizontal: 5,
        paddingVertical: 2,
        flexWrap: 'wrap',
      }}
    >
      <Text>{value}</Text>
    </View>
  </View>
)

const ComplianceRow = ({ label, value }) => (
  <View
    style={{
      borderBottom: 1,
      flexDirection: 'row',
      paddingHorizontal: 5,
      paddingVertical: 2,
    }}
  >
    <View style={{ width: '50%' }}>
      <Text>{label}</Text>
    </View>
    <View style={{ width: '60%' }}>
      {typeof value === 'string' ? <Text>{value}</Text> : value}
    </View>
  </View>
)

const CompliancePage = ({
  employee,
  orgSettings,
  user,
  idCheckQR,
  idCheckURL,
}) => {
  const splitUrl = idCheckURL.match(/.{1,30}/g)
  const latestDBSCheck = employee?.employee?.dbsChecks?.sort(
    (a, b) => new Date(b.completed) - new Date(a.completed)
  )[0]

  return (
    <Document>
      <Page size="A4" style={{ paddingVertical: 10, fontFamily: 'Helvetica' }}>
        <View
          fixed
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            position: 'center',
            top: 10,
            paddingHorizontal: 20,
            left: 0,
            right: 0,
            width: '100%',
            alignItems: 'center',
          }}
        >
          <Image src={orgSettings.logo} style={{ height: 30 }} />
          <Text style={{ textAlign: 'right', fontSize: 14, color: 'grey' }}>
            {orgSettings.orgName}
          </Text>
        </View>
        <View style={{ paddingHorizontal: 20, gap: 20 }}>
          <View
            style={{
              flexDirection: 'column',
              fontWeight: 'bold',
              paddingVertical: 10,
              gap: 4,
              textAlign: 'center',
            }}
          >
            <Text>Employee Compliance Pack</Text>
            <Text>Clinical Governance Directorate</Text>
          </View>
          <View
            style={{
              borderStyle: 'solid',
              borderColor: '#E32525',
              color: 'red',
              gap: 5,
              fontSize: 12,
              padding: 10,
              textAlign: 'justify',
            }}
          >
            <Text
              style={{
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '14',
              }}
            >
              CONFIDENTIAL
            </Text>
            <Text>
              This document and its contents are confidential and intended
              solely for the intended recipient. If you have received this
              document in error, please notify us immediately and delete it from
              your system. The information contained herein is privileged and
              confidential and is protected by UK Data Protection laws,
              including the Data Protection Act 2018, and the Computer Misuse
              Act 1990. Any unauthorised access, disclosure, distribution, or
              use of this document is strictly prohibited.
            </Text>
          </View>
          <View
            style={{
              flexDirection: 'row',
              borderStyle: 'solid',
            }}
          >
            <View style={{ flexDirection: 'column', width: '70%', flex: 1 }}>
              <TextRow
                label="Name"
                value={`${employee.firstName} ${employee.lastName}`}
              />
              <TextRow
                label="Clinical Role"
                value={employee.employee.clinicalRole}
              />
              <TextRow
                label="Compliance Pack Printed"
                value={moment().format('Do MMMM YYYY HH:mm').toString()}
              />
              <TextRow
                label="Printed by"
                value={`${user.firstName} ${user.lastName}`}
              />
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  fontSize: 12,
                }}
              >
                <Image src={idCheckQR} style={{ width: 100 }} />
                <View style={{ flex: 1 }}>
                  <Text>
                    Check {employee.firstName}'s employee status 24/7 at:
                  </Text>
                  <Link src={idCheckURL}>
                    {splitUrl.map((part, index) => (
                      <Text key={index}>{part}</Text>
                    ))}
                  </Link>
                </View>
              </View>
            </View>
            <View style={{ width: '30%' }}>
              <Image
                src={employee?.photograph ?? avatarBlank}
                style={{ width: '100%', maxHeight: 200 }}
              />
            </View>
          </View>
          <View style={{ borderStyle: 'solid', fontSize: 14 }}>
            <View
              style={{
                flexDirection: 'row',
                backgroundColor: '#268EBB',
                color: 'white',
                padding: 5,
              }}
            >
              <View style={{ width: '50%' }}>
                <Text>Compliance</Text>
              </View>
              <View style={{ width: '50%' }}>
                <Text>Status</Text>
              </View>
            </View>
            {/* TODO <ComplianceRow label="Right to work in UK" value={} /> */}
            {employee.employee.registrationNumber && (
              <ComplianceRow
                label="Registration"
                value={
                  <>
                    <Text>
                      Body: {employee.employee.registrationNumber?.body ?? ''}
                    </Text>
                    <Text>
                      Number:{' '}
                      {employee.employee.registrationNumber?.number ?? ''}
                    </Text>
                    <Text>
                      Expiry Date:{' '}
                      {moment(employee.employee.registrationNumber?.renewDate)
                        .format('DD/MM/YYYY')
                        .toString()}
                    </Text>
                  </>
                }
              />
            )}
            <ComplianceRow
              label="Latest DBS Check"
              value={
                latestDBSCheck &&
                moment(latestDBSCheck?.completed)
                  .format('Do MMMM YYYY')
                  .toString()
              }
            />
            <ComplianceRow
              label="Driving Licence"
              value={
                employee.employee?.personnelInfo?.driving?.licenceNumber
                  ? 'Yes'
                  : 'No'
              }
            />
            <ComplianceRow
              label="Has C1"
              value={
                employee.employee?.personnelInfo?.driving?.hasC1 ? 'Yes' : 'No'
              }
            />
            <ComplianceRow
              label="Blue Light Driving Qualification"
              value={
                employee.employee?.personnelInfo?.driving?.hasBlueLight
                  ? 'Yes'
                  : 'No'
              }
            />
          </View>
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
        <Text style={styles.ambuNet} fixed>
          Powered by AmbuNet &#174;
        </Text>
      </Page>
    </Document>
  )

  // return (
  //   <PDFDownloadLink
  //     document={<DocumentComponent />}
  //     fileName={`${employee.firstName}_${
  //       employee.lastName
  //     }_COMPLIANCE_${moment().format('YYYYMMDD').toString()}`}
  //     style={{ width: '100%' }}
  //   >
  //     {({ blob, url, loading, error }) => (
  //       <Button
  //         variant="contained"
  //         disabled={loading}
  //         size="small"
  //         fullWidth
  //         color={loading ? 'warning' : 'success'}
  //       >
  //         {loading ? 'Loading document...' : 'Download!'}
  //       </Button>
  //     )}
  //   </PDFDownloadLink>
  // )
}

export default CompliancePage
